$(document).on("pubgm_mainsite_float_top rendered", {}, function(event, uniqueId){
    var $this = $("#" + uniqueId);

    // console.log(event);
    // console.log(uniqueId);
    // console.log($this);
let hideTimer;

$(".gr_qrcode").on("mouseenter", function () {
  clearTimeout(hideTimer); // Hủy timer nếu đang đếm
  $(this).find(".downloadqrcode").addClass("active");
});

$(".gr_qrcode").on("mouseleave", function () {
  const $box = $(this).find(".downloadqrcode");
  hideTimer = setTimeout(function () {
    $box.removeClass("active");
  }, 1000); // 3 giây sau mới ẩn
});

});